import classNames from "classnames";
import React from "react";

import { PRICE_OPTIONS } from "@repo/shopify/utils/format";

import useCheckLocation from "@hooks/useCheckLocation";
import useLanguage from "@hooks/useLanguage";

interface IProps {
  variant?: "primary" | "secondary";
  price: number;
  compareAtPrice?: number;
  availableForSale?: boolean;
  className?: string;
  direction?: "horizontal" | "vertical";
  isNegative?: boolean;
}

export default function Price({
  variant = "primary",
  price,
  compareAtPrice = 0,
  availableForSale = true,
  className = "",
  direction = "horizontal",
  isNegative = false,
}: IProps) {
  const { currency, lang } = useLanguage();
  const isSale = Boolean(compareAtPrice && price < compareAtPrice);

  const { isDanielJohnston } = useCheckLocation();

  const formatAmount = (value: number) => {
    const formatValue = Math.abs(value).toLocaleString(lang, PRICE_OPTIONS[lang]);
    return isNegative ? `-${currency}${formatValue}` : `${currency}${formatValue}`;
  };

  return (
    <div
      className={classNames(
        "flex",
        variant === "primary" && [direction === "vertical" ? "flex-col" : "gap-2"],
        variant === "secondary" && [direction === "vertical" ? "flex-col" : "flex-row gap-1"],
        className,
      )}
    >
      {availableForSale ? (
        <>
          {isSale ? (
            <>
              <span className="">{formatAmount(price)}</span>
              <span className="text-dark-grey line-through">{formatAmount(compareAtPrice)}</span>
            </>
          ) : (
            <>{price === 0 ? "Free" : formatAmount(price)}</>
          )}
        </>
      ) : (
        <span className={classNames("whitespace-nowrap", isDanielJohnston ? "text-dj-grey" : "text-grey")}>Out of Stock</span>
      )}
    </div>
  );
}
